import React, { useContext } from 'react'
import StateContext from '../../../../../StateContext'
import FavoriteTeamAPI from '../../../../Profile/FavoriteTeamAPI'

function SingleTeamInfo({team, leagueName, currentSeason}) {
    const appState = useContext(StateContext)
    return (
        <div className="row bg-white">

            <div className="col-12 py-3">
                <div className="row">
                    <div className="col-4 col-md-3">
                        <img src={team?.logo} className="img-fluid" />
                        
                    </div>
                    <div className="col-8 col-md-9">
                        <h2>{team?.name} </h2>
                        <div className="row">
                            <div className="col-6">
                                <p>
                                    <small>{team?.founded}</small><br/>
                                    <small>{team?.country}</small><br/>
                                    <small>{currentSeason}</small>
                                </p>
                            </div>
                            <div className="col-6">
                                <p>
                                    <small>{team?.venue_name}</small><br/>
                                    <small>{team?.venue_capacity}</small><br/>
                                    <small>{leagueName && leagueName}</small>
                                </p>
                            </div>
                        </div>
                        {appState.loggedIn && (
                            <div className="col-12">
                                <FavoriteTeamAPI team={team} />
                            </div>
                        )}

                    </div>
                </div>                               
            </div>
        </div>
    )
}
export default SingleTeamInfo